//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  TextField,
  Tooltip,
} from '@mui/material';
import { ToggleOn, ToggleOff } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer            } from 'components/Spacer.jsx';
import { ExpressionContext } from '../ExpressionContext/ExpressionContext';
import { DocumentSelect    } from '../ExpressionView/components/Expression/components/DocumentSelect/DocumentSelect.jsx';

// === API ===
import { on, removeListener } from 'api/prokey/prokey.websocket';

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function InfoView() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const navigate    = useNavigate();

  const { rule, updateRule } = useContext( ExpressionContext );

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    container: {
      gridColumn   : 1        ,
      gridRow      : 1        ,
      width        : '100%'   ,
      overflow     : 'hidden' ,
      padding      : '12px'   ,
      borderRadius : '12px'   ,
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    container_exp: {
      height       : '100%'   ,
      width        : '100%'   ,
      overflow     : 'hidden' ,
      borderRadius : '12px'   ,
    },
    container_exp_2: {
      width    : '100%' ,
      height   : 'calc( 100% - 4rem )' ,
      overflow : 'auto' ,
      backgroundColor: theme.palette.background.secondary[theme.palette.mode],
    },
    header: {
      display: 'flex',
      fontSize: '2rem',
    },
    border_1: {
      display: 'flex',
      borderRadius: '12px',
      width: '100%',
    },
    button_toggle: {
      width  : '3rem',
      height : '3rem',
      color: rule.is_active ? 'green' : 'red',
      fontSize: 40,
    },
  }

  const CONTAINER = {
    style: _styles.container,
  };
  const HEADER = {
    style: _styles.header,
  };
  const BUTTON_TOGGLE = {
    sx: _styles.button_toggle,
    onClick: onClick_Toggle,
    name: 'da_toggle_rule_active_btn',
  };
  const TEXT_DESCRIPTION = {
    sx: {width: '100%'},
    defaultValue: rule.description,
    multiline : true,
    onChange : (event) => updateRule( { description: event.target.value } ),
  };
    
  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function listenerRuleCreateResonse( data ) {
      //-----------------------------------------------------------------
      navigate( '/analytics/rules/' + data.id , { replace: true })
    }

    on( 'RULE_CREATE_RESPONSE', listenerRuleCreateResonse )

    return () => {
      removeListener( 'RULE_CREATE_RESPONSE' , listenerRuleCreateResonse );
    };
  }, [] ); // empty dependency = called only once at startup

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_Toggle() {
    //-----------------------------------------------------------------
    updateRule( { is_active: !rule.is_active } )
  }
  
  //-----------------------------------------------------------------
  function onChange_Document( value ) {
    //-----------------------------------------------------------------
    updateRule( { tags: { ...rule.tags, document: value.numcode } } );
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const active_icon = rule.is_active ? <ToggleOn { ...BUTTON_TOGGLE } /> : <ToggleOff { ...BUTTON_TOGGLE } />;
    return (
      <div { ...CONTAINER } >
        <div { ...HEADER }>
          Description:
          <Spacer fill />
          <Tooltip title='Toggle active' placement='top'>
            {active_icon}
          </Tooltip>
        </div>
        <Spacer />
        <TextField { ...TEXT_DESCRIPTION } />
        <Spacer height='2rem' />
        <div { ...HEADER }>
          Document:
          <Spacer height='2rem' />
          <DocumentSelect onChange={onChange_Document} numcode={rule.tags?.document} />
        </div>
        <Spacer height='2rem' />
      </div>
    );
  }

  //#endregion

  return display();
}
